'use strict';

angular.module('webAgro1App').directive('colheita', function (ColheitaService) {
    var PESO_PADRAO_SACO_KG = 60;

    return {
      templateUrl: 'views/directives/colheita_template.html',
      restrict: 'AE',
      scope: {
        safra: '=',
        gleba: '=',
        atividade: '='
      },
      link: function (scope) {
        scope.$watchGroup(['safra', 'gleba', 'atividade'], function(newValues, oldValues, scope) {
          scope.colheita = {};
          if (scope.safra && scope.gleba && scope.atividade) {
            scope.colheita = {
              loading: true
            };
            var params = {
              safra: scope.safra,
              gleba: scope.gleba,
              atividade: scope.atividade,
            };
            ColheitaService.getQuantidadeColhida(params).then(function(result) {
              if (result.data) {
                scope.colheita = {
                  loading: false,
                  dados: result.data,
                  bruto: result.data.peso_bruto / result.data.qt_area / PESO_PADRAO_SACO_KG,
                  liquido: result.data.peso_liquido / result.data.qt_area / PESO_PADRAO_SACO_KG,
                  data_inicial: result.data.data_inicial,
                  data_final: result.data.data_final,
                  descontos: {
                    percentual_impurezas: result.data.descontos.percentual_impurezas,
                    descontos_impurezas: result.data.descontos.descontos_impurezas / result.data.qt_area / PESO_PADRAO_SACO_KG,
                    percentual_umidade: result.data.descontos.percentual_umidade,
                    descontos_umidade: result.data.descontos.descontos_umidade / result.data.qt_area / PESO_PADRAO_SACO_KG,
                    descontos_outros: result.data.descontos.descontos_outros / result.data.qt_area / PESO_PADRAO_SACO_KG
                  }
                };
              }
            }).finally(function() {
              scope.colheita.loading = false;
            });
          }
        });
      }
    };
  });
